import { DataPath } from '../DataPath';
export var ExprPath;
(function (ExprPath) {
    function fromExprNode(node) {
        const { path } = node;
        if (path.length === 0) {
            throw new Error(`Empty access path`);
        }
        if (path.length === 1) {
            return DataPath.make([path[0].name]);
        }
        else {
            return DataPath.make([path[0].name, path[1].name]);
        }
    }
    ExprPath.fromExprNode = fromExprNode;
    function fromParseNode(node) {
        switch (node.type) {
            case "Identifier":
            case "AccessIdentifier":
            case "AccessExpression": {
                return DataPath.make(makeAccessPath(node));
            }
            default: {
                return DataPath.make([]);
            }
        }
    }
    ExprPath.fromParseNode = fromParseNode;
    function makeAccessPath(node) {
        switch (node.type) {
            case "AccessExpression": {
                return makeAccessPath(node.object).concat(node.member.name);
            }
            case "AccessIdentifier":
            case "Identifier": {
                return [node.name];
            }
            default: {
                return [];
            }
        }
    }
    ExprPath.makeAccessPath = makeAccessPath;
})(ExprPath || (ExprPath = {}));
